import { useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useSingleMinigrid } from '../../../hook'
import { planBTAPI } from '../../../../planBT/services/planAPI'
import styles from './PlanBTLink.module.scss'

export default function PlanBTLinkPresenter() {
  const navigate = useNavigate()
  const {
    singleMinigridQuery: { data: minigrid },
  } = useSingleMinigrid()

  const allPlansQuery = useQuery({
    queryKey: ['allPlanBTForMinigridLink'],
    queryFn: () => planBTAPI.getAllPlanBT(0, 0),
    staleTime: 60 * 1000,
  })

  const plan = minigrid?.minigrid_id
    ? allPlansQuery.data?.data?.find((p) => p.plan_minigrid === minigrid.minigrid_id)
    : undefined

  if (!plan?.plan_id) return null

  const handleClick = () => {
    navigate(`/main/plan-bt-v2/${plan.plan_id}`)
  }

  return (
    <button
      type="button"
      className={styles.btn}
      onClick={handleClick}
      title={`Voir le Plan BT du minigrid « ${minigrid?.minigrid_name ?? ''} »`}
    >
      Voir Plan BT
    </button>
  )
}
